import axios from 'axios'

export default {
    getComplaints(equipmentId) {
        return axios.get(`/api/equipment/${equipmentId}/complaints`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/complaintcodeselector/api.js